export const getShippingServiceName = (serviceCode) => {
  if (!serviceCode) return null;
  if (serviceCode.includes('ups')) {
    return 'UPS';
  }
  if (serviceCode.includes('usps')) {
    return 'USPS';
  }
  if (serviceCode.includes('fedex')) {
    return 'FedEx';
  }
  if (serviceCode.includes('DOM')) {
    return 'Canada Post';
  }
  if (serviceCode.includes('purolator')) {
    return 'Purolator';
  }
  return serviceCode;
};
